/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../connect/v2/common/money';
import '../../../sub2/data';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "resources": {
                "nested": {
                  "ProductInventory": {
                    "fields": {
                      "type": {
                        "type": "squareup.solidshop.v2.resources.ProductInventory.InventoryType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "status": {
                        "type": "squareup.solidshop.v2.resources.ProductInventory.Status",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "InventoryType": {
                        "values": {
                          "NORMAL": 1,
                          "SALES": 2,
                          "WARRANTY": 3
                        }
                      },
                      "Status": {
                        "values": {
                          "IN_STOCK": 1,
                          "OUT_OF_STOCK": 2
                        }
                      }
                    }
                  },
                  "ProductRelation": {
                    "fields": {
                      "type": {
                        "type": "squareup.solidshop.v2.resources.ProductRelation.RelationType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "productKey": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "metadata": {
                        "type": "squareup.solidshop.v2.resources.ProductRelation.RelationMetadata",
                        "id": 3,
                        "rule": "repeated"
                      }
                    },
                    "nested": {
                      "RelationMetadata": {
                        "fields": {
                          "key": {
                            "type": "string",
                            "id": 1,
                            "rule": "required"
                          },
                          "value": {
                            "type": "string",
                            "id": 2,
                            "rule": "required"
                          }
                        }
                      },
                      "RelationType": {
                        "values": {
                          "ADD_ON": 1,
                          "ALTERNATIVE": 2,
                          "UPSELL": 3,
                          "COMPATIBLE": 4
                        }
                      }
                    }
                  },
                  "DisplayField": {
                    "fields": {
                      "type": {
                        "type": "squareup.solidshop.v2.resources.DisplayField.FieldType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "content": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "FieldType": {
                        "values": {
                          "TEXT": 1,
                          "RICH_TEXT": 2
                        }
                      }
                    }
                  },
                  "ProductSpecification": {
                    "fields": {
                      "type": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "body": {
                        "type": "squareup.solidshop.v2.resources.DisplayField",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ProductImage": {
                    "fields": {
                      "type": {
                        "type": "squareup.solidshop.v2.resources.ProductImage.ImageType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "url": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "altText": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ImageType": {
                        "values": {
                          "GALLERY": 1,
                          "TILE": 2,
                          "BANNER": 3
                        }
                      }
                    }
                  },
                  "ProductMetadata": {
                    "fields": {
                      "title": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "keywords": {
                        "type": "string",
                        "id": 3,
                        "rule": "repeated"
                      }
                    }
                  },
                  "DisplayData": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "description": {
                        "type": "squareup.solidshop.v2.resources.DisplayField",
                        "id": 2,
                        "rule": "optional"
                      },
                      "subtitle": {
                        "type": "squareup.solidshop.v2.resources.DisplayField",
                        "id": 3,
                        "rule": "optional"
                      },
                      "disclaimer": {
                        "type": "squareup.solidshop.v2.resources.DisplayField",
                        "id": 4,
                        "rule": "optional"
                      },
                      "specifications": {
                        "type": "squareup.solidshop.v2.resources.ProductSpecification",
                        "id": 5,
                        "rule": "repeated"
                      },
                      "highlights": {
                        "type": "squareup.solidshop.v2.resources.DisplayField",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "images": {
                        "type": "squareup.solidshop.v2.resources.ProductImage",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "metadata": {
                        "type": "squareup.solidshop.v2.resources.ProductMetadata",
                        "id": 8,
                        "rule": "optional"
                      },
                      "shortDescription": {
                        "type": "squareup.solidshop.v2.resources.DisplayField",
                        "id": 9,
                        "rule": "optional"
                      }
                    }
                  },
                  "ProductPrice": {
                    "fields": {
                      "price": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "startsAt": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "expiresAt": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "ProductFinancingOffer": {
                    "fields": {
                      "costPerInstallment": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "numberOfInstallments": {
                        "type": "int32",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "ProductProperties": {
                    "fields": {
                      "isFeatured": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "PlanPricing": {
                    "fields": {
                      "fixedPricing": {
                        "type": "squareup.sub2.data.FixedPricing",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  },
                  "Plan": {
                    "fields": {
                      "token": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "freeTrialDuration": {
                        "type": "squareup.sub2.data.Duration",
                        "id": 3,
                        "rule": "optional"
                      },
                      "renewalCycle": {
                        "type": "squareup.sub2.data.Duration",
                        "id": 4,
                        "rule": "optional"
                      },
                      "pricing": {
                        "type": "squareup.solidshop.v2.resources.PlanPricing",
                        "id": 5,
                        "rule": "optional"
                      },
                      "pricingModel": {
                        "type": "squareup.sub2.data.Pricing",
                        "id": 6,
                        "rule": "optional"
                      }
                    }
                  },
                  "ProductVariant": {
                    "fields": {
                      "productKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "token": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Product": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "createdAt": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "productKey": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "slug": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "price": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "inventory": {
                        "type": "squareup.solidshop.v2.resources.ProductInventory",
                        "id": 6,
                        "rule": "repeated"
                      },
                      "productRelations": {
                        "type": "squareup.solidshop.v2.resources.ProductRelation",
                        "id": 7,
                        "rule": "repeated"
                      },
                      "displayData": {
                        "type": "squareup.solidshop.v2.resources.DisplayData",
                        "id": 8,
                        "rule": "optional"
                      },
                      "prices": {
                        "type": "squareup.solidshop.v2.resources.ProductPrice",
                        "id": 9,
                        "rule": "repeated"
                      },
                      "financingOffers": {
                        "type": "squareup.solidshop.v2.resources.ProductFinancingOffer",
                        "id": 10,
                        "rule": "repeated"
                      },
                      "masterVariantId": {
                        "type": "string",
                        "id": 11,
                        "rule": "optional"
                      },
                      "sku": {
                        "type": "string",
                        "id": 12,
                        "rule": "optional"
                      },
                      "financingOfferPreview": {
                        "type": "squareup.solidshop.v2.resources.ProductFinancingOffer",
                        "id": 13,
                        "rule": "optional"
                      },
                      "properties": {
                        "type": "squareup.solidshop.v2.resources.ProductProperties",
                        "id": 14,
                        "rule": "optional"
                      },
                      "url": {
                        "type": "string",
                        "id": 15,
                        "rule": "optional"
                      },
                      "plan": {
                        "type": "squareup.solidshop.v2.resources.Plan",
                        "id": 16,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE ProductInventory @ squareup/solidshop/v2/resources/product.proto at 13:1
 */
export const ProductInventory = $root.lookupType('squareup.solidshop.v2.resources.ProductInventory');
fixType(ProductInventory);
Builder.createAndAttachToType(ProductInventory);
/**
 * SOURCE InventoryType @ squareup/solidshop/v2/resources/product.proto at 14:3
 */
ProductInventory.InventoryType = $root.lookupEnum('squareup.solidshop.v2.resources.ProductInventory.InventoryType').values;
/**
 * SOURCE Status @ squareup/solidshop/v2/resources/product.proto at 25:3
 */
ProductInventory.Status = $root.lookupEnum('squareup.solidshop.v2.resources.ProductInventory.Status').values;
/**
 * SOURCE ProductRelation @ squareup/solidshop/v2/resources/product.proto at 40:1
 */
export const ProductRelation = $root.lookupType('squareup.solidshop.v2.resources.ProductRelation');
fixType(ProductRelation);
Builder.createAndAttachToType(ProductRelation);
/**
 * SOURCE RelationMetadata @ squareup/solidshop/v2/resources/product.proto at 41:3
 */
ProductRelation.RelationMetadata = $root.lookupType('squareup.solidshop.v2.resources.ProductRelation.RelationMetadata');
fixType(ProductRelation.RelationMetadata);
Builder.createAndAttachToType(ProductRelation.RelationMetadata);
/**
 * SOURCE RelationType @ squareup/solidshop/v2/resources/product.proto at 46:3
 */
ProductRelation.RelationType = $root.lookupEnum('squareup.solidshop.v2.resources.ProductRelation.RelationType').values;
/**
 * SOURCE DisplayField @ squareup/solidshop/v2/resources/product.proto at 70:1
 */
export const DisplayField = $root.lookupType('squareup.solidshop.v2.resources.DisplayField');
fixType(DisplayField);
Builder.createAndAttachToType(DisplayField);
/**
 * SOURCE FieldType @ squareup/solidshop/v2/resources/product.proto at 71:3
 */
DisplayField.FieldType = $root.lookupEnum('squareup.solidshop.v2.resources.DisplayField.FieldType').values;
/**
 * SOURCE ProductSpecification @ squareup/solidshop/v2/resources/product.proto at 86:1
 */
export const ProductSpecification = $root.lookupType('squareup.solidshop.v2.resources.ProductSpecification');
fixType(ProductSpecification);
Builder.createAndAttachToType(ProductSpecification);
/**
 * SOURCE ProductImage @ squareup/solidshop/v2/resources/product.proto at 94:1
 */
export const ProductImage = $root.lookupType('squareup.solidshop.v2.resources.ProductImage');
fixType(ProductImage);
Builder.createAndAttachToType(ProductImage);
/**
 * SOURCE ImageType @ squareup/solidshop/v2/resources/product.proto at 95:3
 */
ProductImage.ImageType = $root.lookupEnum('squareup.solidshop.v2.resources.ProductImage.ImageType').values;
/**
 * SOURCE ProductMetadata @ squareup/solidshop/v2/resources/product.proto at 116:1
 */
export const ProductMetadata = $root.lookupType('squareup.solidshop.v2.resources.ProductMetadata');
fixType(ProductMetadata);
Builder.createAndAttachToType(ProductMetadata);
/**
 * SOURCE DisplayData @ squareup/solidshop/v2/resources/product.proto at 127:1
 */
export const DisplayData = $root.lookupType('squareup.solidshop.v2.resources.DisplayData');
fixType(DisplayData);
Builder.createAndAttachToType(DisplayData);
/**
 * SOURCE ProductPrice @ squareup/solidshop/v2/resources/product.proto at 156:1
 */
export const ProductPrice = $root.lookupType('squareup.solidshop.v2.resources.ProductPrice');
fixType(ProductPrice);
Builder.createAndAttachToType(ProductPrice);
/**
 * SOURCE ProductFinancingOffer @ squareup/solidshop/v2/resources/product.proto at 167:1
 */
export const ProductFinancingOffer = $root.lookupType('squareup.solidshop.v2.resources.ProductFinancingOffer');
fixType(ProductFinancingOffer);
Builder.createAndAttachToType(ProductFinancingOffer);
/**
 * SOURCE ProductProperties @ squareup/solidshop/v2/resources/product.proto at 175:1
 */
export const ProductProperties = $root.lookupType('squareup.solidshop.v2.resources.ProductProperties');
fixType(ProductProperties);
Builder.createAndAttachToType(ProductProperties);
/**
 * SOURCE PlanPricing @ squareup/solidshop/v2/resources/product.proto at 180:1
 */
export const PlanPricing = $root.lookupType('squareup.solidshop.v2.resources.PlanPricing');
fixType(PlanPricing);
Builder.createAndAttachToType(PlanPricing);
/**
 * SOURCE Plan @ squareup/solidshop/v2/resources/product.proto at 184:1
 */
export const Plan = $root.lookupType('squareup.solidshop.v2.resources.Plan');
fixType(Plan, {
  pricingModel: { required: true },
});
Builder.createAndAttachToType(Plan);
/**
 * SOURCE ProductVariant @ squareup/solidshop/v2/resources/product.proto at 204:1
 */
export const ProductVariant = $root.lookupType('squareup.solidshop.v2.resources.ProductVariant');
fixType(ProductVariant);
Builder.createAndAttachToType(ProductVariant);
/**
 * SOURCE Product @ squareup/solidshop/v2/resources/product.proto at 212:1
 */
export const Product = $root.lookupType('squareup.solidshop.v2.resources.Product');
fixType(Product);
Builder.createAndAttachToType(Product);
